import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/eventActions';
import { Link } from 'react-router';
import PermissionWrapper from '../../components/common/PermissionWrapper';

import EventList from '../../components/event/EventList';

class EventsPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillMount = this.componentWillMount.bind(this);
  }

  componentWillMount() {
    this.props.actions.loadEvents();
  }

  render() {
    return (
      <div className="events-page-container container">
        <h1 className="page-header clearfix">Arrangement
          <PermissionWrapper allowed={['super_admin', 'event_admin']}>
            <Link
              to={"/arrangement/ny"}
              className="btn btn-primary pull-right">
              Nytt arrangement
            </Link>
          </PermissionWrapper>
        </h1>
        <EventList
          eventList={this.props.eventList}
          loading={this.props.loadingEvents} />
      </div>
    );
  }
}

EventsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  eventList: PropTypes.array.isRequired,
  loadingEvents: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    eventList: state.events.eventList,
    loadingEvents: state.events.loadingEvents,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsPage);



/** WEBPACK FOOTER **
 ** ./src/containers/events/EventsPage.js
 **/